import { render, staticRenderFns } from "./TriggerAdded.vue?vue&type=template&id=3d590424&scoped=true"
import script from "./TriggerAdded.vue?vue&type=script&lang=js"
export * from "./TriggerAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d590424",
  null
  
)

export default component.exports